import { httpClient } from '@/infra/protocols/http';
import { IVoiceDTO } from '@/modules/voices/dtos/voice.dto';
import { IVoice } from '@/modules/voices/entities/voice.entity';
import { VoiceMapper } from '@/modules/voices/mappers/voice.mapper';

export async function getVoices(): Promise<GetVoicesService.Response> {
  const response = await httpClient.get<IVoiceDTO[]>(`/v1/vozes`);
  return response.map(VoiceMapper.toPresentation);
}

export namespace GetVoicesService {
  export type Response = IVoice[];
}
